// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tdrs-intro {
  color: rgb(14, 19, 25);
  padding: 200px 0px 300px;
}

.intro-title {
  max-width: 700px;
}

.logo {
  width: 48px;
}

.header-logo {
  width: 80px;
}

h1.jumbotron {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 0;
}

.flex-inner {
  flex: 1;
}

@media screen and (min-width: 769px) and (max-width: 863px) {
  .smartpath-split .inner {
    min-width: 275px;
  }
  .smartpath-split .inner img {
    width: 20%;
  }
}
@media screen and (min-width: 769px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .smartpath-split .inner {
    min-width: 275px;
  }
  .smartpath-split .inner img {
    width: 20%;
  }
}
@media screen and (min-width: 501px) and (max-width: 768px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .smartpath-split .inner {
    max-width: 80vw;
    min-height: 25vh;
    align-self: center;
  }
  .smartpath-split .inner img {
    width: 10% !important;
  }
  .intro-title {
    margin: 0px 30px;
    max-width: 95%;
  }
}
@media screen and (max-width: 500px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .smartpath-split .inner {
    max-width: 60vw;
    min-height: 35vh;
    align-self: center;
  }
  .smartpath-split .inner img {
    width: 10% !important;
  }
  .intro-title {
    margin: 0px 30px;
    max-width: 95%;
  }
}
@media screen and (max-width: 768px) {
  .brand {
    margin: 16px 24px;
    width: calc(100% - 48px);
  }
  .intro-title {
    margin: 0px 30px;
  }
  .smartpath-split .inner {
    min-width: 275px;
  }
  .smartpath-split .inner img {
    width: 20%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/component/header/header.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,wBAAA;AACF;;AACA;EACE,gBAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AADA;EACE,WAAA;AAIF;;AAFA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,OAAA;AAKF;;AAHA;EACE;IACE,gBAAA;EAMF;EALE;IACE,UAAA;EAOJ;AACF;AAHA;EACE;IACE,gBAAA;EAKF;EAJE;IACE,UAAA;EAMJ;AACF;AAFA;EACE;IACE,eAAA;IACA,gBAAA;IAIA,kBAAA;EACF;EAJE;IACE,qBAAA;EAMJ;EAFA;IACE,gBAAA;IACA,cAAA;EAIF;AACF;AADA;EACE;IACE,eAAA;IACA,gBAAA;IAIA,kBAAA;EAAF;EAHE;IACE,qBAAA;EAKJ;EADA;IACE,gBAAA;IACA,cAAA;EAGF;AACF;AAAA;EACE;IACE,iBAAA;IACA,wBAAA;EAEF;EAAA;IACE,gBAAA;EAEF;EACA;IACE,gBAAA;EACF;EAAE;IACE,UAAA;EAEJ;AACF","sourcesContent":[".tdrs-intro {\n  color: rgb(14, 19, 25);\n  padding: 200px 0px 300px;\n}\n.intro-title {\n  max-width: 700px;\n}\n.logo {\n  width: 48px;\n}\n.header-logo {\n  width: 80px;\n}\nh1.jumbotron {\n  font-size: 48px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.flex-inner {\n  flex: 1;\n}\n@media screen and (min-width: 769px) and (max-width: 863px) {\n  .smartpath-split .inner {\n    min-width: 275px;\n    img {\n      width: 20%;\n    }\n  }\n}\n// Add for IE\n@media screen and (min-width: 769px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .smartpath-split .inner {\n    min-width: 275px;\n    img {\n      width: 20%;\n    }\n  }\n}\n// Add for IE\n@media screen and (min-width: 501px) and (max-width: 768px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .smartpath-split .inner {\n    max-width: 80vw;\n    min-height: 25vh;\n    img {\n      width: 10% !important;\n    }\n    align-self: center;\n  }\n  .intro-title {\n    margin: 0px 30px;\n    max-width: 95%;\n  }\n}\n// Add for IE\n@media screen and (max-width: 500px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .smartpath-split .inner {\n    max-width: 60vw;\n    min-height: 35vh;\n    img {\n      width: 10% !important;\n    }\n    align-self: center;\n  }\n  .intro-title {\n    margin: 0px 30px;\n    max-width: 95%;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .brand {\n    margin: 16px 24px;\n    width: calc(100% - 48px);\n  }\n  .intro-title {\n    margin: 0px 30px;\n  }\n\n  .smartpath-split .inner {\n    min-width: 275px;\n    img {\n      width: 20%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
